// extracted by mini-css-extract-plugin
export var adjacentSlide = "_p9-9";
export var arrowButtonContainer = "_p9-5";
export var arrowButtonIcon = "_p9-6";
export var carouselArrowButton = "_p9-2";
export var carouselElementContainer = "_p9-1";
export var currentSlide = "_p9-8";
export var left = "_p9-3";
export var otherSlide = "_p9-a";
export var productCarouselContainer = "_p9-0";
export var right = "_p9-4";
export var sliderOverflow = "_p9-7";